import React from 'react'
import { compose } from 'recompose'
import { withElementActions } from 'store/canvas/hocsCanvas'
import styled from 'styled-components'
import muiThemeable from 'material-ui/styles/muiThemeable'
/*eslint-disable */
const switchColor = (bool, primaryColor, secondaryColor) => {
  return bool ? primaryColor : secondaryColor
}

const Icon = styled.i`
  padding-left: 5px;
  margin-left: 5px;
  border-left: 1px solid #f5f5f5;
  :hover {
    cursor: pointer;
  }
`

const Wrapper = styled.div`
  ${() => ({
    position: 'relative',
    zIndex: 1000,
    borderWidth: '1px',
    borderStyle: 'solid',
    minWidth: '97px',
    borderColor: 'transparent',
    '&:hover': {
      cursor: 'pointer',
    }
  })}
`

const ElementSpan = styled.span`
  ${({ bg }) => ({
    left: 0,
    height: '20px',
    position: 'absolute',
    zIndex: 1002,
    color: '#ffffff',
    fontSize: '10px',
    padding: '0 5px',
    opacity: 0.82,
    minWidth: '102px',
    backgroundColor: bg,
    ':hover': {
      cursor: 'pointer',
    }
  })}
`

const EnhancedSpan = styled(ElementSpan)`
  ${() => ({
    minWidth: 'auto',
    letterSpacing: '1px',
    borderBottom: '1px solid #ffffff',
    ':hover': {
      backgroundColor: '#ff4300',
    }
  })}
`

const ElementBar = compose(
  muiThemeable(),
  withElementActions(),
)(
  ({
    style,
    onSelectElement,
    onOverElement,
    onLeaveElement,
    onDeleteElement,
    onSwitchUp,
    onSwitchDown,
    refElement,
    children,
    isSelected,
    isActive,
    muiTheme: {
      palette: {
        primary1Color,
        accent1Color,
      }
    },
    attachedParents,
    showParents,
    toggleParents,
  }) => {
    return (
      <Wrapper
        className="element-bar"
        style={{
          ...isActive && {
            borderColor: switchColor(isSelected, primary1Color, accent1Color)
          },
          ...style,
        }}
        onMouseOver={(e) => {
          e.stopPropagation()
          return onOverElement()
        }}
        onMouseLeave={(e) => {
          e.stopPropagation()
          return onLeaveElement()
        }}
        onClick={(e) => {
          // parent will not fire an event
          e.stopPropagation()
          return onSelectElement()
        }}
      >
        {(isSelected && showParents) &&
          attachedParents.map(({ id, refElement: name, onClick }, i) => (
            <EnhancedSpan
              key={id}
              bg={switchColor(isSelected, primary1Color, accent1Color)}
              style={{
                top: -((i+1) * 20) -1,
              }}
              onClick={onClick}
            >
              {name}
            </EnhancedSpan>
          ))
        }
        {isActive &&
          <ElementSpan
            bg={switchColor(isSelected, primary1Color, accent1Color)}
            onClick={toggleParents}
          >
            {refElement}
            <Icon
              className="fa fa-trash"
              onClick={(e) => {
                e.stopPropagation()
                return onDeleteElement()
              }}
            />
            <Icon
              className="fa fa-chevron-down"
              onClick={(e) => {
                e.stopPropagation()
                return onSwitchDown()
              }}
            />
            <Icon
              className="fa fa-chevron-up"
              onClick={(e) => {
                e.stopPropagation()
                return onSwitchUp()
              }}
            />
          </ElementSpan>
        }
        <div style={style}>
          {children}
        </div>
      </Wrapper>
    )
  }
)

ElementBar.propTypes = {}
ElementBar.defaultProps = {}

export default ElementBar



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/components/ElementBar.js